(ns common.widgets.checkbox
  (:require ["@mui/material/Checkbox$default" :as Checkbox]
            ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            [uix.core :refer [$ defui]]))

(defui checkbox
  [{:keys [on-change label value disabled? id] :as props
    :or {disabled? false}}]
  ($ FormControlLabel
     {:label label
      :control ($ Checkbox
                  (merge (dissoc props :on-change :label :value :disabled? :error)
                         {:checked (or value false)
                          :onChange #(when on-change
                                       (on-change (-> % .-target .-checked)))
                          :disabled disabled?
                          :data-testid (str "checkbox-" id)}))}))
